<template>
  <modal :titulo="titulo" id="simulacao-registro-notas" :loading="loading">
    <template #actions>
      <li class="list-inline-item">
        <a @click.prevent.stop="imprimir(ficha)" title="Imprimir" href>
          <i class="fal fa-print"></i>
        </a>
      </li>
    </template>

    <p v-if="loading">
      Processando atos: {{resumo.atual | inteiro}}/{{resumo.total | inteiro}}
    </p>

    <template v-if="fichaAtualizada">

      <template v-for="(atoItem, i) in erros">
        <erro-validacao :ato="atoItem" :protocolo="protocolo" :key="atoItem.id + '-' + i" servico="RegistroNotas"
                        :exibeNomeServico="false" @abrirErro="abrirErro(...$event)" />
      </template>

      <card v-for="atoItem in fichaAtualizada.atos" :key="atoItem.id" :titulo="`${atoItem.tipoServico.opcoes.titulo}`">
        <card-content>

          <div v-if="atoItem.livroFolhaSimulado" class="mb-2">
            <small class="text-muted">
              <i class="fal fa-book mr-1"></i>
              <strong>{{ atoItem.livroFolhaSimulado.livroNome }}</strong>
              — Livro {{ atoItem.livroFolhaSimulado.livro }},
              Folha{{ atoItem.livroFolhaSimulado.folhaInicial !== atoItem.livroFolhaSimulado.folhaFinal ? 's' : '' }}
              {{ atoItem.livroFolhaSimulado.folhaInicial }}{{ atoItem.livroFolhaSimulado.folhaInicial !== atoItem.livroFolhaSimulado.folhaFinal ? ' a ' + atoItem.livroFolhaSimulado.folhaFinal : '' }}
              <template v-if="atoItem.livroFolhaSimulado.quantidadeFolhas"> — {{ atoItem.livroFolhaSimulado.quantidadeFolhas }} folha{{ atoItem.livroFolhaSimulado.quantidadeFolhas === 1 ? '' : 's' }}</template>
            </small>
          </div>

          <div v-if="atoItem.envolvidos && atoItem.envolvidos.length" class="mb-2">
            <small class="text-muted"><strong>Envolvidos:</strong></small>
            <ul class="list-unstyled ml-2 mb-0">
              <li v-for="env in atoItem.envolvidos" :key="env.id">
                <small>{{ env.indicadorPessoalVersao ? env.indicadorPessoalVersao.nome : env.nome }}
                  <span class="text-muted" v-if="env.papel">— {{ env.papel }}</span>
                </small>
              </li>
            </ul>
          </div>

          <div v-if="atoItem.minuta" v-html="atoItem.minuta" class="texto-minuta bg-sidebar-soft overflow-auto"></div>

        </card-content>
      </card>

      <card titulo="Dados" v-if="mostrarDados">
        <card-table class="table-borderless">
          <thead>
            <tr>
              <th width="33%" class="pl-2">CAMPO</th>
              <th width="33%">ANTES</th>
              <th width="33%">DEPOIS</th>
            </tr>
          </thead>
          <tbody>

            <tr v-if="ficha.status != fichaAtualizada.status">
              <td class="pl-2">Situação</td>
              <td class="text-truncate">{{formatarStatus(ficha.status)}}</td>
              <td class="text-truncate">{{formatarStatus(fichaAtualizada.status)}}</td>
            </tr>

          </tbody>
        </card-table>
      </card>

      <card titulo="Atos Praticados">
        <card-content>

          <div v-for="atoItem in fichaAtualizada.atos" :key="'praticado-' + atoItem.id">

            <p class="mb-2" @dblclick="exportar(atoItem, atoItem.codigoStr)">
              <strong>{{atoItem.tipoServico.opcoes.titulo}}</strong>
            </p>

          </div>

        </card-content>
      </card>

    </template>

  </modal>
</template>

<script>
import FrontBusiness from "@/business/FrontBusiness";
import IndicadorPessoalBusiness from "@/business/indicadores/IndicadorPessoalBusiness.js";
import RegistroNotasBusiness from "@/business/indicadores/RegistroNotasBusiness.js";
import AtoBusiness from "@/business/protocolo/AtoBusiness";
import ProtocoloDocumentoBusiness from "@/business/protocolo/ProtocoloDocumentoBusiness.js";
import RegistroNotasSimulacaoBusiness from "@/business/protocolo/simulacao/RegistroNotasSimulacaoBusiness";
import Utils from "@/commons/Utils";
import Card from "@/components/Layout/components/Card.vue";
import CardContent from "@/components/Layout/components/CardContent.vue";
import CardTable from "@/components/Layout/components/CardTable.vue";
import ImprimirFicha from "@/components/Livros/ImprimirFicha.vue";
import Modal from "@/components/Modal";
import ErroValidacao from "@/views/Protocolo/Atos/Simulacao/ErroValidacao.vue";
import CertidaoBusiness from "@/business/protocolo/CertidaoBusiness";

export default {

    name: "SimularRegistroNotas",
    components: {CardContent, CardTable, Card, ErroValidacao, Modal},
    props: {
      id: String,
      protocolo: Object,
      tipoItem: {
        type: String,
        default: 'ATO'
      },
      modelo: String,
      ato: String,
      texto: String
    },

    modal: {
        width: 1100
    },

    data() {
      return {
        loading: false,
        ficha: {},
        fichaAtualizada: null,
        erros: [],
        resumo : {
          total : 0,
          atual : 0,
          inicio : this.$moment(),
          fim : null
        }
      }
    },

    computed: {
      titulo() {
        let protocolo = this.protocolo;
        return `Simular Resultado: ${FrontBusiness.nomearProtocolo(protocolo.dominio, protocolo.tipoProtocolo, protocolo.codigo, protocolo.tipoCadastro)}`
      },

      mostrarDados() {
        return this.ficha.status != this.fichaAtualizada.status
      }

    },

    beforeMount() {
      this.load();
    },

    methods: {

      formatarStatus(status) {
        return RegistroNotasBusiness.formatarNomeStatus(status);
      },

      async load() {
        this.loading = true;

        let documentos = [], atos = [], p1, p2, p3;

        IndicadorPessoalBusiness.resetCache();

        if(this.id) {
          p1 = RegistroNotasBusiness.getById(this.id).then(f => this.ficha = f);
        }

        let business;
        switch (this.tipoItem) {
          case 'ATO':
            if (this.protocolo?.id) {
              business = AtoBusiness;
              p2 = ProtocoloDocumentoBusiness.listar(this.protocolo.id).then(f => documentos = f);
              p3 = business.listarPorFicha(this.protocolo.id, 'indicador', this.id).then(f => atos = f);
            }
            break;
          case 'CERTIDAO':
            if (this.protocolo?.id) {
              business = CertidaoBusiness;
              p3 = business.listar(this.protocolo.id).then(f => documentos = f);
            }
            break;
        }

        let usuarioLogado = this.$root.usuarioLogado;
        await Promise.all([p1, p2, p3]);

        if (!atos.length && this.ato) {
          let ato = await business.getById(null, this.ato);
          if(ato.envolvidos) ato.envolvidos.forEach(e => e.indicadorPessoalVersaoId = e.indicadorPessoalVersao.id);
          atos = [ato];
        }

        this.resumo.total = atos.length;

        if(this.ato){
          let result;
          switch (this.tipoItem) {
            case 'ATO':
              result = await RegistroNotasSimulacaoBusiness.gerarMinuta(Utils.clone(this.protocolo), Utils.clone(this.ficha), atos, documentos, this.resumo, {id: this.ato, texto : this.texto}, usuarioLogado);
              let ato = result.atos.find(a => a.id == this.ato);
              FrontBusiness.closeModal(ato);
              break;
            case 'CERTIDAO':
              result = await business.gerarMinuta(this.protocolo.id, this.ato, this.modelo);
              FrontBusiness.closeModal(result);
              break;
          }

          return;
        }

        let result = await RegistroNotasSimulacaoBusiness.simular(Utils.clone(this.protocolo), Utils.clone(this.ficha), atos, documentos, this.resumo, usuarioLogado);

        this.resumo.fim = this.$moment();

        this.fichaAtualizada = result.ficha;
        this.fichaAtualizada.atos = result.atos;
        this.erros = result.atos.filter(a => a.erros.length);

        this.loading = false;
      },

      async abrirErro(ato, areaErroSimulacao) {
        let atoId = ato.id != null ? ato.id : ato.atoId;
        FrontBusiness.closeModal({id: atoId, area: areaErroSimulacao});
      },

      exportar(ato, name) {
        console.debug('debug', name, ato.debug);
        const texto = Utils.stringify(ato.debug);
        console.debug('debug', name, texto);
      },

      async imprimir(ficha){
        FrontBusiness.openModal(ImprimirFicha, {id: ficha.id, tipo: ficha.livro, codigo: ficha.codigo,
          simulacao: true});
      },

    }

  }
</script>

<style lang=scss>
  #simulacao-registro-notas {
    .texto-minuta {
      max-height: 400px;
      padding: 10px;
      p {
        white-space: pre-line;
      }
    }
  }
</style>
